import React from 'react';
import {IntlProvider, FormattedMessage} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
  fields: [
    {
      type: 'text',
      name: 'email',
      props: {
        label: (
          <p>
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.searchPanel.email' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'uid',
      props: {
        label: (
          <p>
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.searchPanel.uid' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'username',
      props: {
        label: (
          <p>
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.searchPanel.username' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'firstName',
      props: {
        label: (
          <p>
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.searchPanel.firstName' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'lastName',
      props: {
        label: (
          <p>
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.searchPanel.lastName' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'commentId',
      props: {
        label: (
          <p>
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.searchPanel.commentId' />
            </IntlProvider>
          </p>
        )
      }
    },
    // {
    //   type: 'siteIdDropdown',
    //   name: 'siteId'
    // },
    {
      type: 'checkbox',
      name: 'adminsOnly',
      props: {
        boolean: true,
        value: false,
        options: [
          {
            key: 'adminsOnly',
            value: true,
            text: (
              <IntlProvider locale='en' messages={enUSmessage}>
                <FormattedMessage id='userManagement.searchPanel.adminsOnly' />
              </IntlProvider>
            )
          }
        ]
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserSearchPanel/userSearchFormConfig.jsx